<script>
    export let viewbox;
    export let zoomSpeed = 0.1;
    export const handles = { start, stop, move, zoom, reset };

    const [x, y, width, height] = $viewbox;

    let active = false;
    let offset = [0, 0];
    let zoomScale = 1;
    $: $viewbox = [
        zoomScale * (-width / 2) + offset[0],
        zoomScale * (-height / 2) + offset[1],
        zoomScale * width,
        zoomScale * height,
    ];

    // --- API
    function start(e) {
        move(e);
        active = true;
    }

    function stop(e) {
        active = false;
    }

    function move(e) {
        if (active) {
            offset = [
                offset[0] - e.movementX * zoomScale,
                offset[1] - e.movementY * zoomScale,
            ];
        }
    }

    function reset(_) {
        zoomScale = 1;
        offset = [0, 0];
    }

    function zoom(e) {
        zoomScale = Math.min(
            Math.max(zoomScale * 1 + zoomSpeed * Math.sign(e.deltaY), 0.1),
            1
        );
    }
</script>
